import { CelebrityQueueAPI } from '@sscale/celebritysdk';

const celebrityQueueAPI = new CelebrityQueueAPI();

export default celebrityQueueAPI;
